import { apiHooks } from '../hooks/api-hooks';
import { IBoxCustomisationConfigAvailableOptions, IBoxCustomisationConfigDefaultProduce } from '../pack-house-generated-api';
import { IBoxCustomisationProduceDto } from './box-customisation-produce.dto';

export type ISwappedBoxCustomisationConfigAvailableOptions = IBoxCustomisationConfigAvailableOptions & {
    produceObj: IBoxCustomisationProduceDto | undefined;
};
export interface IBoxCustomisationConfigDefaultProduceDto
    extends Omit<IBoxCustomisationConfigDefaultProduce, 'available_options'> {
    id: string;
    produceObj: IBoxCustomisationProduceDto | undefined;
    available_options: ISwappedBoxCustomisationConfigAvailableOptions[];
}

export const createDefaultProduceDto = (
    source: IBoxCustomisationConfigDefaultProduce,
): IBoxCustomisationConfigDefaultProduceDto => {
    const allProduces = apiHooks.packHouse.getProduceListFromCache();
    const produceObj = allProduces?.list.find((produce) => produce.code === source.code);

    return {
        ...source,
        id: source.code || '',
        produceObj,
        available_options:
            source.available_options?.map((option) => {
                const produceObj = allProduces?.list.find((produce) => produce.code === option.code);
                return {
                    ...option,
                    produceObj,
                };
            }) || [],
    };
};
